/*
 * fn: stripString
 *
 * Strips a string into a comparable search key
 *
 */
import { stripExtraSpaces } from './stripExtraSpaces'

export const stripString = (input: string | undefined) =>
  stripExtraSpaces(
    input
      ?.normalize('NFD')
      .toLowerCase()
      .replace(/[^\w\s]/g, ''),
  )
